module.exports = __webpack_public_path__ + "img/34.ad0e7139.jpg";